var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.xAxis.length)?_c('div',[_c('highcharts',{attrs:{"options":_vm.chartData}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }